import styled from 'styled-components';
import { colors } from '@/presentation/reusables/constants';

const SValidationResult = styled.div`
  > div {
    &:nth-of-type(2) {
      border-radius: 4px;
      margin-top: 8px;
    }
  }
`;

const SValidationResultBody = styled.div`
  padding: 12px 12px;
  border: 1px solid #a8cbe2;
  border-radius: 4px;
  background-color: #f7fafb;

  > p {
    color: ${colors.text02};
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 4px;
  }
`;

const SValidationResultList = styled.div``;

const SValidationResultItem = styled.div<{
  isValid: boolean;
}>`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  border-bottom: 1px solid #bfd8e9;

  > svg {
    height: 14px;
    max-height: 14px;
    max-width: 14px;
    min-height: 14px;
    min-width: 14px;
    width: 14px;
    color: ${({ isValid }) => (isValid ? '#007f38' : '#e8212b')};
  }

  > p {
    color: ${colors.text02};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    flex-grow: 1;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export {
  SValidationResult,
  SValidationResultList,
  SValidationResultBody,
  SValidationResultItem
};
